import React, { useState, createContext, useEffect, useContext } from "react";
import { ApiService } from "../services/api.service";
import Cookie from "js-cookie";
import { UserModel } from "../types/user";
import { generateUUID } from "../helpers";
import { CartContext } from "../context/cartContext";
import { getUser, clearUser, buildUser } from "../services/auth.service";
import { useNavigate } from "react-router-dom";
interface AuthProviderProps {
  children: React.ReactNode;
}

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5011";

export const AuthContext = createContext({} as any);

export const AuthProvider = ({ children }: AuthProviderProps) => {
  // const [userData, setUserData] = useState({
  //   // userGuid: "",
  //   // userFirstName: "",
  //   // refToken: "",
  //   // currency: "",
  //   // userSurname: "",
  //   // userEmail: "",
  //   // userStatus: 0,
  //   // Country: 0,
  //   // account: 0,
  //   // partner: 0,
  //   // priceClassID: 0,
  //   // adminContact: 0,
  //   // userHouseNo: "",
  //   // userStreet: "",
  //   // userPostcode: "",
  //   // userCounty: "",
  //   // userCity: "",
  //   // userSubscribe: "",
  //   displayName: "",
  // });

  const [userData, setUserData] = useState({} as any | null);
  //const navigate = useNavigate();

  useState<UserModel[] | null | string>();

  const apiService = new ApiService();

  useEffect(() => {
    let cancelled = false;

    const authUser = async () => {
      console.log("Fetching user data...");

      let res = await fetch(`${API_BASE_URL}/api/User/Me`, {
        credentials: "include",
      });

      if (res.ok) {
        const user = await res.json();
        console.log("User data fetched:", user);
        if (!cancelled) {
          setUserData(user);
          //navigate("/");
        }
        return;
      }

      if (res.status === 401) {
        const refresh = await fetch(`${API_BASE_URL}/api/User/RefreshToken`, {
          method: "POST",
          credentials: "include",
        });

        if (refresh.ok) {
          // 3) Retry /me after refresh
          res = await fetch(`${API_BASE_URL}/api/user/me`, {
            credentials: "include",
          });
          if (res.ok) {
            const user = await res.json();
            if (!cancelled) {
              setUserData(user);
              //navigate("/");
            }
            return;
          }
        }
      }

      console.log("Response received:", res);

      const cookieVal = Cookie.get("token");
      if (cookieVal !== undefined) {
        let user = buildUser(cookieVal);
        if (user === undefined) {
        } else {
          setUserData(user);
        }
      }
      // setUserData({ userGuid: "" });
    };
    authUser();
  }, []);

  return (
    <AuthContext.Provider value={{ userData, setUserData }}>
      {children}
    </AuthContext.Provider>
  );
};
